import ManageOperatorTable from './ManageOperatorTable'

const ManageOperator = {
  Table: ManageOperatorTable,
}

export default ManageOperator
